module.exports = __webpack_public_path__ + "static/media/login-bg.afaa7eb1.jpg";